import {
  attribution
} from "@/common/dictionary.js";
import {
  setValue,
  clearValue,
  getUrlQuery
} from "@/common/util.js";
import {
  validMobile,
  validMoney
} from "@/common/valid.js";
import api from "@/services/otherTable.js";

const family = (data) => {
  let form = {
    relationship: {
      formType: "a-input",
      placeholder: "请输入与本人关系",
      label: "与本人关系：",
      value: undefined,
      rules: [{
        required: true,
        message: "请输入与本人关系",
        trigger: "change"
      }]
    },
    name: {
      formType: "a-input",
      placeholder: "请输入姓名",
      label: "姓名：",
      value: undefined,
      rules: [{
        required: true,
        message: "请输入姓名",
        trigger: "change"
      }]
    },
    workUnit: {
      formType: "a-input",
      placeholder: "请输入工作单位",
      label: "工作单位：",
      value: undefined
    },
    duties: {
      formType: "a-input",
      placeholder: "请输入职务",
      label: "职务：",
      value: undefined
    },
    telephone: {
      formType: "a-input",
      placeholder: "请输入联系电话",
      label: "联系电话：",
      value: undefined,
      rules: [validMobile()]
    }
  }
  if (data.row) {
    return setValue(data.row, form)
  } else {
    return clearValue(form)
  }
}
const contract = (data) => {
  let form = {
    contractCode: {
      formType: "a-input",
      placeholder: "请输入合同编码",
      label: "合同编码：",
      value: undefined,
      rules: [{
        required: true,
        message: "请输入合同编码",
        trigger: "change"
      }]
    },
    nature: {
      formType: "a-select",
      placeholder: "请选择合同属性",
      label: "合同属性：",
      value: undefined,
      code: 119,
      rules: [{
        required: true,
        message: "请选择合同属性",
        trigger: "change"
      }],
      change: async function (formData, item) {
        if (item.value == 119002) {
          let query = getUrlQuery();
          let id = query.userId || query.talentsId
          let res = await api.getPrevTime({
            id: id
          });
          if (res.data.data) {
            formData.time.pickerOptions = {
              disabledDate: function (date) {
                return date.getTime() < new Date(res.data.data) - 3600 * 1000 * 24
              }
            }
          }
        } else {
          formData.time.pickerOptions = {
            disabledDate: function (date) {
              return false
            }
          }
        }
      }
    },
    companyId: {
      formType: "a-select",
      placeholder: "请选择所属公司",
      label: "所属公司：",
      value: undefined,
      api: "getCompany",
      props: {
        label: "companyName",
        value: "id"
      },
      rules: [{
        required: true,
        message: "请选择所属公司",
        trigger: "change"
      }]
    },
    attribution: {
      formType: "a-select",
      placeholder: "请选择劳动关系所在地区",
      label: "劳动关系所在地区：",
      value: undefined,
      options: attribution,
      rules: [{
        required: true,
        message: "请选择劳动关系所在地区",
        trigger: "change"
      }]
    },
    noLimitStartTime: {
      formType: "a-date-picker",
      label: "合同时间：",
      type: "date",
      value: '',
      rules: [{
        required: true,
        message: "请选择合同时间",
        trigger: "change"
      }],
      placeholder: "开始日期 - 长期",
      pickerOptions: {},
      displayWith: (from) => {
        // 当【合同属性】为‘无固定期劳动合同’时显示
        return from.nature && from.nature.value === 119005;
      }
    },
    time: {
      formType: "a-date-picker",
      startPlaceholder: "开始日期",
      endPlaceholder: "结束日期",
      label: "合同时间：",
      type: "daterange",
      value: undefined,
      rules: [{
        required: true,
        message: "请选择合同时间",
        trigger: "change"
      }],
      pickerOptions: {},
      displayWith: (from) => {
        // 当【合同属性】不为‘无固定期劳动合同’时显示
        return from.nature && from.nature.value !== 119005;
      }
    },
    station: {
      formType: "a-input",
      placeholder: "请输入合同岗位",
      label: "合同岗位：",
      value: undefined,
      rules: [{
        required: true,
        message: "请输入合同岗位",
        trigger: "change"
      }]
    }
  }
  if (data.row) {
    let result = setValue(data.row, form)
    let str = data.row.startTime.split(" ")[0]
    let end = data.row.endTime.split(" ")[0]
    result.time.value = [str, end]
    return result
  } else {
    return clearValue(form)
  }
}

const work = (data) => {
  let form = {
    time: {
      formType: "a-date-picker",
      startPlaceholder: "开始日期",
      endPlaceholder: "结束日期",
      label: "起止时间：",
      type: "monthrange",
      value: undefined,
      rules: [{
        required: true,
        message: "请选择起止时间",
        trigger: "change"
      }]
    },
    workUnit: {
      formType: "a-input",
      placeholder: "请输入工作单位",
      label: "工作单位：",
      value: undefined,
      rules: [{
        required: true,
        message: "请输入工作单位",
        trigger: "change"
      }]
    },
    deparPosition: {
      formType: "a-input",
      placeholder: "请输入职务",
      label: "职务：",
      value: undefined,
      rules: [{
        required: true,
        message: "请输入职务",
        trigger: "change"
      }]
    },
    salary: {
      formType: "a-input",
      placeholder: "请输入薪资",
      label: "薪资：",
      value: undefined,
      rules: [validMoney()]
    },
    reterence: {
      formType: "a-input",
      placeholder: "请输入证明人",
      label: "证明人：",
      value: undefined
    },
    telephone: {
      formType: "a-input",
      placeholder: "请输入联系电话",
      label: "联系电话：",
      value: undefined,
      rules: [validMobile()]
    },
  }
  if (data.row) {
    let result = setValue(data.row, form)
    let str = data.row.startTime.split(" ")[0]
    let end = data.row.endTime.split(" ")[0]
    result.time.value = [str, end]
    return result
  } else {
    return clearValue(form)
  }
}

const educate = (data) => {
  let form = {
    time: {
      formType: "a-date-picker",
      startPlaceholder: "开始日期",
      endPlaceholder: "结束日期",
      label: "起止时间：",
      type: "daterange",
      value: undefined,
      rules: [{
        required: true,
        message: "请选择起止时间",
        trigger: "change"
      }]
    },
    school: {
      formType: "a-input",
      placeholder: "请输入毕业院校",
      label: "毕业院校：",
      value: undefined,
      rules: [{
        required: true,
        message: "请输入毕业院校",
        trigger: "change"
      }]
    },
    major: {
      formType: "a-input",
      placeholder: "请输入专业",
      label: "专业：",
      value: undefined,
    },
    education: {
      formType: "a-select",
      placeholder: "请选择学历",
      label: "学历：",
      code: 101,
      value: undefined,
      rules: [{
        required: true,
        message: "请选择学历",
        trigger: "change"
      }]
    },
    nature: {
      formType: "a-select",
      placeholder: "请选择学历性质",
      label: "学历性质：",
      code: 121,
      value: undefined,
      rules: [{
        required: true,
        message: "请选择学历性质",
        trigger: "change"
      }]
    },
  }
  if (data.row) {
    let result = setValue(data.row, form)
    let str = data.row.startTime.split(" ")[0]
    let end = data.row.endTime.split(" ")[0]
    result.time.value = [str, end]
    return result
  } else {
    return clearValue(form)
  }
}

const evaluate = (data) => {
  let form = {
    interviewerName: {
      formType: "a-input",
      placeholder: "请输入面试人姓名",
      label: "面试人姓名：",
      value: undefined,
      rules: [{
        required: true,
        message: "请输入面试人姓名",
        trigger: "change"
      }]
    },
    syntheticEvaluation: {
      formType: "a-select",
      placeholder: "请选择综合评估",
      label: "综合评估：",
      value: undefined,
      code: 150,
      rules: [{
        required: true,
        message: "请选择综合评估",
        trigger: "change"
      }]
    },
    interiewResult: {
      formType: "a-select",
      placeholder: "请选择面试结论",
      label: "面试结论：",
      value: undefined,
      code: 151,
      rules: [{
        required: true,
        message: "请选择面试结论",
        trigger: "change"
      }]
    },
    remark: {
      formType: "a-textarea",
      placeholder: "请输入面试评语",
      label: "面试评语：",
      value: undefined
    }
  }
  if (data && data.row) {
    return setValue(data.row, form)
  } else {
    return clearValue(form)
  }
}

export default {
  family,
  contract,
  work,
  educate,
  evaluate
}



// WEBPACK FOOTER //
// ./src/components/otherTable/formData.js